import { render } from "./EnvironmentCommunityView.vue?vue&type=template&id=37db848a&scoped=true"
import script from "./EnvironmentCommunityView.vue?vue&type=script&lang=js"
export * from "./EnvironmentCommunityView.vue?vue&type=script&lang=js"

import "./EnvironmentCommunityView.vue?vue&type=style&index=0&id=37db848a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37db848a"]])

export default __exports__